export default __webpack_public_path__ + "static/media/wave-01.27a19dfe.png";